module.exports = __webpack_public_path__ + "static/media/ta-img.ba2631c3.jpg";